import React from 'react';
import { Link } from 'react-router-dom';
import { SITE, TESTIMONIALS, FAQS } from '../data/siteData';
import narendra from '../assets/pro.png';
import trust from '../assets/trust.jpeg';

import { useScrollReveal } from '../hooks/useScrollReveal';
import Icon from '../components/Icon';
import './About.css';

const IMGS = {
  heroBg: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1400&q=80&auto=format&fit=crop',
  story:  trust,
};

function FAQItem({ q, a, index }) {
  const [open, setOpen] = React.useState(false);
  const { ref, visible } = useScrollReveal();
  return (
    <div ref={ref} className={`faq-item${open?' open':''}${visible?' visible':''}`} style={{transitionDelay:`${index*0.07}s`}}>
      <button className="faq-q" onClick={()=>setOpen(v=>!v)}>
        <span>{q}</span><span className="faq-toggle">{open?'−':'+'}</span>
      </button>
      <div className="faq-a">{a}</div>
    </div>
  );
}

function ValueCard({ icon, title, text, index }) {
  const { ref, visible } = useScrollReveal();
  return (
    <div key={index} ref={ref} className={`value-card${visible?' visible':''}`} style={{transitionDelay:`${index*0.1}s`}}>
      <div className="vc-icon">{icon}</div>
      <div className="vc-title">{title}</div>
      <div className="vc-text">{text}</div>
    </div>
  );
}

function TestimonialCard({ testimonial, index }) {
  const { ref, visible } = useScrollReveal();
  return (
    <div key={index} ref={ref} className={`abt-card${visible?' visible':''}`} style={{transitionDelay:`${index*0.1}s`}}>
      <div className="abt-stars">{'★'.repeat(testimonial.rating)}</div>
      <blockquote className="abt-text">"{testimonial.text}"</blockquote>
      <div className="abt-author">
        <div className="abt-avatar">{testimonial.name[0]}</div>
        <div><div className="abt-name">{testimonial.name}</div><div className="abt-role">{testimonial.role}</div></div>
      </div>
    </div>
  );
}

function StatItem({ stat, index }) {
  const { ref, visible } = useScrollReveal();
  return (
    <div key={index} ref={ref} className={`ast-item${visible?' visible':''}`} style={{transitionDelay:`${index*0.1}s`}}>
      <div className="ast-num">{stat.num}</div>
      <div className="ast-label">{stat.label}</div>
    </div>
  );
}

export default function About() {
  return (
    <div className="about-page page-wrapper">
      {/* Hero */}
      <div className="ab-hero">
  <img src={IMGS.heroBg} alt="" className="ab-hero-bg-img"/>
  <div className="ab-hero-overlay"/>
  <div className="ab-hero-inner">
    <div className="ab-hero-text">
      <div className="section-label" id="ab">About LMS</div>
      <h1 className="section-title">Trusted Wealth &amp; Finance<br/><span style={{color:'#7DE48A'}}>Advisory Since 2000 </span></h1>
      <p className="section-sub" id="founded" style={{marginTop:20}}>
        Founded in 2000, LMS Marketing & Services was built with a singular mission — to bring institutional-quality financial advisory to individuals and businesses in Hyderabad, India and abroad with integrity, transparency, and excellence.
      </p>
    </div>
    <div className="ab-hero-card">
      <div className="ab-avatar-wrapper">
        <img 
          src={narendra} 
          alt="G.M. Narendra" 
          className="ab-avatar-img" 
        />
      </div>
      <div className="ab-name">G.M. Narendra</div>
      <div className="ab-title">Management Consultant &amp; Founder</div>
      <div className="ab-creds">
        {SITE.consultant.credentials.map(c=><span key={c} className="ab-cred">{c}</span>)}
      </div>
      <div className="ab-quote">"Wealth is not about how much you earn — it's about how well you manage, protect, and grow what you have."</div>
      <div className="ab-contact-row">
        <a href={`tel:${SITE.contact.phone}`} className="btn-primary" style={{fontSize:12,padding:'11px 20px'}}>📞 Call Now</a>
        <a href={`mailto:${SITE.contact.email}`} className="btn-ghost" style={{fontSize:12,padding:'10px 20px'}}>✉ Email</a>
      </div>
    </div>
  </div>
</div>

      {/* Story */}
      <section className="ab-story">
        <div className="abs-inner">
          <div className="abs-left">
            <div className="section-label">Our Story</div>
            <h2 className="section-title">Built on Trust,<br/><span className="green">Driven by Results</span></h2>
            <div className="green-divider" style={{margin:'22px 0'}}/>
            <p className="abs-text">LMS Marketing & Services was born from a recognition that most Indians lack access to truly personalized, unbiased financial advice. Too often, people are sold products rather than given advice.</p>
            <p className="abs-text">G.M. Narendra founded LMS Marketing & Services with the vision of becoming a true wealth partner to families and businesses in Hyderabad — with qualifications spanning M.Com, MBA, and PGDCS, combined with deep market experience.</p>
            <p className="abs-text">Today, LMS manages wealth and financial products for 1000+ clients across Hyderabad, India and abroad — from young professionals starting their first SIP to HNIs managing multi-crore portfolios.</p>
          </div>
          <div className="abs-right">
            <div className="abs-img-wrap">
              <img src={IMGS.story} alt="Financial planning" className="abs-img"/>
              {/* <div className="abs-img-caption">"Personalised advice that has transformed 1000+ financial lives since 2000"</div> */}
            </div>
            {/* abs-timeline removed */}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="ab-values">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:0}}>
            <div className="section-label" style={{justifyContent:'center'}}>Core Values</div>
            <h2 className="section-title">What We <span className="green">Stand For</span></h2>
          </div>
          <div className="ab-values-grid">
            {[
              {icon:'🎯',title:'Client-First Always',text:'Every recommendation is made with your best interest at heart — not commissions, not targets. Pure advisory.'},
              {icon:'🔍',title:'Radical Transparency',text:'Full disclosure on fees, products, and risks. You deserve to understand every investment you make.'},
              {icon:'📚',title:'Continuous Learning',text:'Markets evolve. We stay ahead through continuous education and research to serve you with current expertise.'},
              {icon:'🤝',title:'Long-Term Partnership',text:'We measure success by your financial journey, not one-time sales. Our relationships span decades.'},
            ].map((v,i)=> (
              <ValueCard key={i} icon={v.icon} title={v.title} text={v.text} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="ab-stats">
        {SITE.stats.map((s,i)=> (
          <StatItem key={i} stat={s} index={i} />
        ))}
      </section>

      {/* Testimonials */}
      <section className="ab-testi">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:48}}>
            <div className="section-label" style={{justifyContent:'center'}}>Client Stories</div>
            <h2 className="section-title">Words from <span className="green">Our Clients</span></h2>
          </div>
          <div className="ab-testi-grid">
            {TESTIMONIALS.map((t,i)=> (
              <TestimonialCard key={i} testimonial={t} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="ab-faq">
        <div className="abf-inner">
          <div className="abf-left">
            <div className="section-label">FAQ</div>
            <h2 className="section-title">Common<br/><span className="green">Questions</span></h2>
            <p className="section-sub" style={{marginTop:16}}>Can't find your answer? Call us directly.</p>
            <div style={{marginTop:28}}>
              <a href={`tel:${SITE.contact.phone}`} className="btn-primary">📞 {SITE.contact.phone}</a>
            </div>
          </div>
          <div className="abf-right">
            {FAQS.map((f,i)=><FAQItem key={i} q={f.q} a={f.a} index={i}/>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="ab-cta">
        <div className="ab-cta-inner">
          <h2 className="section-title">Begin Your Financial<br/><span style={{color:'#7DE48A'}}>Transformation Today</span></h2>
          <p className="section-sub" style={{margin:'20px auto 40px',maxWidth:540,color:'rgba(255,255,255,.6)'}}>
            Schedule a free, no-obligation consultation with G.M. Narendra and discover how LMS can transform your financial life.
          </p>
          <div style={{display:'flex',gap:14,justifyContent:'center',flexWrap:'wrap'}}>
            <Link to="/contact" className="btn-primary">Book Consultation →</Link>
            <a href={`tel:${SITE.contact.phone}`} className="btn-primary">📞 Call Now</a>
          </div>
        </div>
      </section>
    </div>
  );
}